export default __webpack_public_path__ + "images/met-weekly-goal.svg";